"use client";
import { Search } from "lucide-react";
import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, MapPin } from "lucide-react";
import SearchBox from "@/core/common/SearchBox";

import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import { useRouter } from "next/navigation";

const formatDate = (d: Date) => d.toISOString().slice(0, 10);

interface IProps {
  city?: { name: string; slug: string }[];
}

const LocationDate = ({ city }: IProps) => {
  const router = useRouter();

  const [selectedCity, setSelectedCity] = useState<{
    name: string;
    slug: string;
  } | null>(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [open, setOpen] = useState(false);
  const [locationOpen, setLocationOpen] = useState(false);

  // const startOfToday = new Date();
  const startOfToday = new Date(new Date().getFullYear() - 1, 0, 1, 0, 0, 0, 0);
  return (
    <div className="hidden md:flex">
      <div>
        <div className="flex flex-row md:space-x-8 md:px-9 md:py-2">
          <DropdownMenu open={locationOpen} onOpenChange={setLocationOpen}>
            <DropdownMenuTrigger className="flex flex-row gap-2">
              <div>
                <p className="typography-sub-h2-medium text-grey-900">
                  Location
                </p>
                <p className="typography-mid-body-light text-grey-400">
                  {selectedCity ? selectedCity.name : "Where are you going"}
                </p>
              </div>
              <ChevronDown className="inline ml-1 w-4 h-4 text-grey-900" />
            </DropdownMenuTrigger>

            <DropdownMenuContent
              side="bottom"
              align="start"
              className="w-52 p-4 bg-white shadow-xl border rounded-xl space-y-4"
            >
              <SearchBox
                className="rounded-lg w-full placeholder:typography-large-body placeholder:text-grey-200 pl-2"
                placeholder="Search By Place..."
              />
              {city && (
                <div className="max-h-40 overflow-y-auto custom-scrollbar">
                  {city.map((c, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedCity(c);
                        setLocationOpen(false);
                      }}
                      className="py-2 px-3 w-full hover:bg-grey-100 rounded-lg cursor-pointer typography-mid-body-light text-grey-900 inline-flex gap-2"
                    >
                      <MapPin className="text-grey-400" size={20} />
                      {c?.name}
                    </div>
                  ))}
                </div>
              )}
            </DropdownMenuContent>
          </DropdownMenu>

          <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger className="flex flex-row gap-2 cursor-pointer">
              <div>
                <p className="typography-sub-h2-medium text-grey-900">Date</p>
                <p className="typography-mid-body-light text-grey-400">
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : "Choose date"}
                </p>
              </div>
              <ChevronDown className="inline ml-1 w-4 h-4 text-grey-900" />
            </DropdownMenuTrigger>

            <DropdownMenuContent
              side="bottom"
              align="start"
              className="w-auto p-4 bg-white shadow-xl border rounded-xl"
            >
              <DateRange
                editableDateInputs
                moveRangeOnFirstSelection={false}
                ranges={dateRange}
                minDate={startOfToday}
                onChange={(item: any) => {
                  const selection = item.selection;

                  setDateRange([selection]);

                  const { startDate, endDate } = selection;

                  if (
                    startDate &&
                    endDate &&
                    startDate.getTime() !== endDate.getTime()
                  ) {
                    setStartDate(formatDate(startDate));
                    setEndDate(formatDate(endDate));

                    setOpen(false);
                  }
                }}
              />
            </DropdownMenuContent>
          </DropdownMenu>

          <hr className="border-l border-grey-900 h-14" />

          <div>
            <button
              type="button"
              onClick={() => {
                const params = new URLSearchParams();

                if (selectedCity) params.set("search", selectedCity.slug);
                if (startDate) params.set("start_date", startDate);
                if (endDate) params.set("end_date", endDate);

                router.push(`/package?${params.toString()}`);
              }}
              className="ml-4 typography-sub-h3-light bg-primary-500 px-8 py-3 rounded-xl items-center justify-center text-white transition-shadow duration-200 ease-in-out shadow-[0px_2px_12px_0px_rgba(0,0,0,0.18)] hover:bg-primary-600 hover:shadow-[inset_0_2px_12px_0_#0000001C]"
            >
              <Search className="inline w-7 h-7 pr-2 text-white" />
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationDate;
